import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment.onprem";

@Injectable({
  providedIn: "root",
})
export class UrlServices {
  url: string = "";
  client: string = "";

  constructor() {
    this.url = `${environment.envVar.authority}/oauth2/v2.0/authorize?`;
    this.client = `${environment.envVar.clientId}`;
  }
}
